import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ManageOrdersComponent from '@app/components/manage-orders/list';

const ManageOrder: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>Manage Order</PageTitle>
      <ManageOrdersComponent />
    </>
  );
};

export default ManageOrder;
